module.exports = __webpack_public_path__ + "img/menuDetail7.be0dfb58.png";